import { render, staticRenderFns } from "./WellClueManagement.vue?vue&type=template&id=6fc45954&scoped=true"
import script from "./WellClueManagement.vue?vue&type=script&lang=js"
export * from "./WellClueManagement.vue?vue&type=script&lang=js"
import style0 from "./WellClueManagement.vue?vue&type=style&index=0&id=6fc45954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc45954",
  null
  
)

export default component.exports